const defaultStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0,.75)',
  },
};

export default defaultStyles;
